import retrieveAlert from 'app/modules/alerts/sagas/retrieveAlert';
import retrieveAlertTransactions from 'app/modules/alerts/sagas/retrieveAlertTransactions';
import changeAlertComponentStatus from 'app/modules/alerts/sagas/changeAlertComponentStatus';
import createAlert from 'app/modules/alerts/sagas/createAlert';
import editAlert from 'app/modules/alerts/sagas/editAlert';
import retrieveAlertEntities from 'app/modules/alerts/sagas/retrieveAlertEntities';
import retrieveAlertHistogram from 'app/modules/alerts/sagas/retrieveAlertHistogram';
import retrieveAlertActionEvents from 'app/modules/alerts/sagas/retrieveAlertActionEvents';

const sagaRegistry = [
  retrieveAlert,
  retrieveAlertTransactions,
  retrieveAlertEntities,
  changeAlertComponentStatus,
  createAlert,
  editAlert,
  retrieveAlertHistogram,
  retrieveAlertActionEvents,
];

export default sagaRegistry;
